import React from 'react';
import { Autocomplete, Stack, TextField } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const AssignmentGradeFormDialog = ({ open, onClose, onSubmit, editingAssignment, formData, setFormData, classes, scales, saving, isMobile = false }) => (
  <FormDialog open={open} onClose={onClose} onSubmit={onSubmit} title={editingAssignment ? 'Edit Assignment' : 'Assign Grading Scale'} saving={saving} isMobile={isMobile}>
    <Stack spacing={2} sx={{ pt: 1 }}>
      <Autocomplete
        fullWidth
        options={classes}
        value={classes.find((c) => Number(c.id) === Number(formData.class_id)) || null}
        onChange={(_, v) => setFormData({ ...formData, class_id: v?.id || '' })}
        getOptionLabel={(o) => o.name || o.class_name || 'Class'}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        renderInput={(params) => <TextField {...params} label="Class" required />}
      />
      <Autocomplete
        fullWidth
        options={scales}
        value={scales.find((s) => Number(s.id) === Number(formData.grading_scale_id)) || null}
        onChange={(_, v) => setFormData({ ...formData, grading_scale_id: v?.id || '' })}
        getOptionLabel={(o) => `${o.scale_name || 'Scale'} (${o.scale_code || '-'})`}
        isOptionEqualToValue={(o, v) => o.id === v.id}
        renderInput={(params) => <TextField {...params} label="Grading Scale" required />}
      />
      <TextField
        fullWidth type="number" label="Academic Year"
        value={formData.academic_year}
        onChange={(e) => setFormData({ ...formData, academic_year: parseInt(e.target.value, 10) })}
        inputProps={{ min: 2020, max: new Date().getFullYear() + 1 }}
        required
      />
    </Stack>
  </FormDialog>
);

export default AssignmentGradeFormDialog;
